import { render, staticRenderFns } from "./setPriceModal.vue?vue&type=template&id=4580e8db"
import script from "./setPriceModal.vue?vue&type=script&lang=js"
export * from "./setPriceModal.vue?vue&type=script&lang=js"
import style0 from "./setPriceModal.vue?vue&type=style&index=0&id=4580e8db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports